import { useLocation } from 'react-router-dom';

export const selectLastPathname = () => {
  const location = useLocation();
  const pathnameArr = location.pathname.split('/');
  return pathnameArr[pathnameArr.length - 1];
};
